export default __webpack_public_path__ + "static/media/offices3.1315a824.png";